/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Open_MenuInputs */

const en_marketing_open_menu = /** @type {(inputs: Marketing_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

const es_marketing_open_menu = /** @type {(inputs: Marketing_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

const fr_marketing_open_menu = /** @type {(inputs: Marketing_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu`)
};

/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Marketing_Open_MenuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_open_menu = /** @type {((inputs?: Marketing_Open_MenuInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Open_MenuInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_open_menu(inputs)
	if (locale === "es") return es_marketing_open_menu(inputs)
	return fr_marketing_open_menu(inputs)
});